import { on, off, once, hasClass, addClass, removeClass, getStyle, setStyle } from '@didi/mfe-dom';
/**
 * Class for working with DOM
 */
var DOM = /** @class */ (function () {
    function DOM() {
    }
    /**
     * Add event listener
     * @param element
     * @param event
     * @param fn
     */
    DOM.on = function (element, event, fn) {
        on(element, event, fn);
    };
    /**
     * Remove event listener
     * @param element
     * @param event
     * @param fn
     */
    DOM.off = function (element, event, fn) {
        off(element, event, fn);
    };
    /**
     * Add event listener only trigger once
     * @param element
     * @param event
     * @param fn
     */
    DOM.once = function (element, event, fn) {
        once(element, event, fn);
    };
    /**
     * Check if element has class name
     * @param element
     * @param className
     */
    DOM.hasClass = function (element, className) {
        return hasClass(element, className);
    };
    /**
     * Add class name
     * @param element
     * @param className
     */
    DOM.addClass = function (element, className) {
        addClass(element, className);
    };
    /**
     * Remove class name
     * @param element
     * @param className
     */
    DOM.removeClass = function (element, className) {
        removeClass(element, className);
    };
    /**
     * Get style property
     * @param element
     * @param styleName
     */
    DOM.getStyle = function (element, styleName) {
        return getStyle(element, styleName);
    };
    /**
     * Set style property
     * @param element
     * @param styleName
     */
    DOM.setStyle = function (element, styleName, styleValue) {
        setStyle(element, styleName, styleValue);
    };
    return DOM;
}());
export default DOM;
